/*eslint-disable*/
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (!navbarOpen) return;
      if (navRef.current && !navRef.current.contains(event.target)) {
        setNavbarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [navbarOpen]);

  return (
    <>
      <nav
        ref={navRef}
        className="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"
      >
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-end lg:w-auto lg:static lg:block lg:justify-start">
            <button
              className="cursor-pointer leading-none px-3 py-2 border-2 border-solid rounded bg-transparent block lg:hidden outline-none focus:outline-none absolute right-0 z-50"
              style={{ top: "12px", borderColor: "#ffffff" }}
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
              aria-label={navbarOpen ? "Cerrar menu" : "Abrir menu"}
            >
              <span className="relative block" style={{ width: "20px", height: "14px" }}>
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "20px",
                    height: "2px",
                    backgroundColor: "#ffffff",
                    borderRadius: "2px",
                    transform: navbarOpen ? "translateY(6px) rotate(45deg)" : "none",
                    transition: "transform 200ms ease"
                  }}
                ></span>
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    top: "6px",
                    width: "20px",
                    height: "2px",
                    backgroundColor: "#ffffff",
                    borderRadius: "2px",
                    opacity: navbarOpen ? 0 : 1,
                    transition: "opacity 150ms ease"
                  }}
                ></span>
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    top: "12px",
                    width: "20px",
                    height: "2px",
                    backgroundColor: "#ffffff",
                    borderRadius: "2px",
                    transform: navbarOpen ? "translateY(-6px) rotate(-45deg)" : "none",
                    transition: "transform 200ms ease"
                  }}
                ></span>
              </span>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg mt-12 lg:mt-0" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              <li className="flex items-center w-full lg:w-auto">
                <Link
                  className="text-blueGray-700 lg:text-white lg:hover:text-blueGray-200 text-sm font-bold leading-relaxed block w-full lg:w-auto mr-4 py-2 whitespace-nowrap uppercase ml-3"
                  to="/"
                  onClick={() => setNavbarOpen(false)}
                >
                  Home
                </Link>
              </li>
              <li className="flex items-center w-full lg:w-auto">
                <Link
                  className="text-blueGray-700 lg:text-white lg:hover:text-blueGray-200 text-sm font-bold leading-relaxed block w-full lg:w-auto mr-4 py-2 whitespace-nowrap uppercase ml-3"
                  to="/faq"
                  onClick={() => setNavbarOpen(false)}
                >
                  FAQ
                </Link>
              </li>
              <li className="flex items-center w-full lg:w-auto">
                <Link
                  className="text-blueGray-700 lg:text-white lg:hover:text-blueGray-200 text-sm font-bold leading-relaxed block w-full lg:w-auto mr-4 py-2 whitespace-nowrap uppercase ml-3"
                  to="/auth"
                  onClick={() => setNavbarOpen(false)}
                >
                  Login
                </Link>
              </li>
              <li className="flex items-center w-full lg:w-auto">
                <Link
                  className="text-blueGray-700 lg:text-white lg:hover:text-blueGray-200 text-sm font-bold leading-relaxed block w-full lg:w-auto mr-4 py-2 whitespace-nowrap uppercase ml-3"
                  to="/auth/register"
                  onClick={() => setNavbarOpen(false)}
                >
                  Crear cuenta
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
